import { TAccount } from './accounts.types';

/**
 * Determines if an account is a term_loan or business_loan product type
 * @param account: TAccount- An Account object
 * @returns true or false
 */
export const getAccountIsTermLoan = (account: TAccount) => {
    return Boolean(
        ['term_loan', 'business_loan'].includes(account.product_type)
    );
};
